<template>
  <div class="edu-item">
    <div class="edu-row edu-row-title">
      <input ref="firstInputRef" v-model="local.degree" type="text" class="edu-input" placeholder="Degree" />
      <input v-model="local.institution" type="text" class="edu-input" placeholder="Institution" />
    </div>
    <div class="edu-row edu-row-dates">
      <input v-model="local.year" type="text" class="edu-input edu-full" placeholder="Year range (e.g. 2020 – 2024)" />
      <input v-model.number="local.startYear" type="number" class="edu-input edu-short" placeholder="Start year" />
      <input v-model.number="local.endYear" type="number" class="edu-input edu-short" placeholder="End year" />
    </div>
  </div>
</template>

<script setup>
import { ref, watch, defineExpose } from 'vue';

const props = defineProps({
  modelValue: {
    type: Object,
    default: () => ({ degree: '', institution: '', year: '', startYear: null, endYear: null })
  }
});
const emit = defineEmits(['update:modelValue']);

function clone(val) {
  const v = val || {};
  return {
    degree: v.degree ?? '',
    institution: v.institution ?? '',
    year: v.year ?? '',
    startYear: v.startYear != null ? v.startYear : null,
    endYear: v.endYear != null ? v.endYear : null,
  };
}

const local = ref(clone(props.modelValue));
const firstInputRef = ref(null);
let ignoreNextPropUpdate = false;

function focusFirstInput() {
  firstInputRef.value?.focus();
}

defineExpose({ focusFirstInput });

watch(
  () => props.modelValue,
  (v) => {
    if (ignoreNextPropUpdate) {
      ignoreNextPropUpdate = false;
      return;
    }
    local.value = clone(v);
  },
  { deep: true }
);

watch(
  local,
  () => {
    ignoreNextPropUpdate = true;
    emit('update:modelValue', clone(local.value));
  },
  { deep: true }
);
</script>

<style scoped>
.edu-item {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.edu-row {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
}
.edu-row-title {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}
.edu-row-title .edu-input {
  min-width: 0;
}
.edu-row-dates {
  flex-wrap: wrap;
}
.edu-input {
  padding: 10px 14px;
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  background: #ffffff;
  color: var(--text-primary);
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.edu-input::placeholder {
  color: var(--text-muted);
  opacity: 1;
}
.edu-input:hover:not(:disabled) {
  border-color: var(--input-border-hover, var(--border));
}
.edu-input:focus {
  outline: none;
  border-color: var(--focus-ring);
  box-shadow: 0 0 0 2px var(--focus-ring);
}
.edu-full {
  width: 100%;
}
.edu-short {
  width: 100px;
  min-width: 80px;
}
</style>
